import React, { useEffect, useState } from 'react';
import { AiUploadTask, aiUploadQueue } from '../../classroom/aiUploadQueue';

const AiUploadQueueStatus: React.FC = () => {
  const [tasks, setTasks] = useState<AiUploadTask[]>([]);
  useEffect(() => aiUploadQueue.subscribe(setTasks), []);
  if (!tasks.length) return null;

  return <aside className="cd-upload-queue" aria-live="polite" aria-label="Background uploads">
    <strong>AI creation uploads</strong>
    {tasks.map((task) => <div className={`cd-upload-task is-${task.status}`} key={task.id}>
      <div className="cd-upload-task-head">
        <span>{task.label}</span>
        <small>{task.status === 'queued' ? 'Waiting…' : task.status === 'uploading' ? `${task.progress}%` : task.status === 'complete' ? '✓ Saved' : 'Upload failed'}</small>
      </div>
      {task.status === 'uploading' || task.status === 'queued' ? <div className="cd-upload-progress"><i style={{ width: `${task.progress}%` }} /></div> : null}
      {task.canRetry && <button type="button" onClick={() => aiUploadQueue.retry(task.id)}>Retry upload</button>}
      {task.error ? <p>{task.error}</p> : null}
      {(task.status === 'complete' || task.status === 'failed') && <button type="button" onClick={() => aiUploadQueue.dismiss(task.id)} aria-label={`Dismiss ${task.label}`}>×</button>}
    </div>)}
    {tasks.some((task) => task.status === 'uploading' || task.status === 'queued') && <p className="cd-upload-queue-hint">You can keep working. Keep this page open until uploads finish.</p>}
  </aside>;
};

export default AiUploadQueueStatus;
